var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mb-5"},[(_vm.formal)?_c('div',[_vm._v(" "+_vm._s(_vm.statText.questionAppForm)+" ")]):_vm._e(),(!_vm.formal)?_c('div',[_vm._v(" "+_vm._s(_vm.statText.questionAppInf)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }